import '../Hero/Hero.css'


function Hero() {
  return (
    <>
      <div className="cont">
        <div className="img ">
          <img className='img1' src="https://i.imgur.com/Ld3BYi0.png" alt="" />
        </div>
      </div>
    </>
  );
}

export default Hero;